/* Wabrings global UX: nav, header state, predictive search, prefetch, recently viewed, sticky ATC, variant pills */
(function(){
  'use strict';

  /* Announcement marquee: duplicate for seamless loop */
  document.querySelectorAll('.announcement__track').forEach(function(t){
    t.innerHTML = t.innerHTML + t.innerHTML; /* own static markup only */
  });

  /* Header stuck state */
  var header = document.querySelector('.header');
  if(header){
    var onScroll = function(){ header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }

  /* Mobile nav */
  var navToggle = document.querySelector('.nav-toggle');
  if(navToggle){
    navToggle.setAttribute('aria-expanded','false');
    navToggle.addEventListener('click', function(){
      var nav = document.querySelector('.mobile-nav');
      if(!nav) return;
      var open = nav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Quantity steppers */
  document.addEventListener('click', function(e){
    var step = e.target.closest('[data-qty-step]');
    if(!step) return;
    var wrap = step.closest('.qty');
    var input = wrap.querySelector('input');
    var val = (parseInt(input.value,10) || 1) + parseInt(step.getAttribute('data-qty-step'),10);
    input.value = Math.max(1, val);
  });

  /* Variant pills (PDP) */
  var pillWrap = document.querySelector('[data-variant-pills]');
  if(pillWrap){
    pillWrap.addEventListener('click', function(e){
      var pill = e.target.closest('.pill');
      if(!pill || pill.disabled) return;
      pillWrap.querySelectorAll('.pill').forEach(function(p){ p.setAttribute('aria-pressed','false'); });
      pill.setAttribute('aria-pressed','true');
      var id = pill.getAttribute('data-variant-id');
      var cents = pill.getAttribute('data-price');
      var nativeMoney = pill.getAttribute('data-money');
      var price = (window.WabCurrency && window.WabStore && window.WabCurrency !== window.WabStore && window.WabringsCart) ? window.WabringsCart.formatMoney(parseInt(cents,10)) : (nativeMoney || cents);
      document.querySelectorAll('[data-add-to-cart],[data-buy-now]').forEach(function(b){ b.setAttribute('data-variant-id', id); });
      var priceEls = document.querySelectorAll('[data-product-price]');
      for(var pe=0; pe<priceEls.length; pe++){ if(cents){ priceEls[pe].setAttribute('data-cents', cents); } if(nativeMoney!=null){ priceEls[pe].setAttribute('data-native', nativeMoney); } priceEls[pe].textContent = price; }
      var atcPrice = document.querySelector('[data-atc-price]');
      if(atcPrice){ if(cents){ atcPrice.setAttribute('data-cents', cents); } if(nativeMoney!=null){ atcPrice.setAttribute('data-native', nativeMoney); } atcPrice.textContent = price; }
      try{ history.replaceState(null,'', location.pathname + '?variant=' + id); }catch(err){}
    });
  }

  /* Sticky mobile ATC */
  var mainAtc = document.querySelector('[data-add-to-cart][data-pdp]');
  var stickyBar = document.querySelector('.sticky-atc');
  if(mainAtc && stickyBar && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      stickyBar.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin:'-80px 0px 0px 0px' }).observe(mainAtc);
  }

  /* Hover prefetch (instant.page pattern, 65ms) */
  var prefetched = {};
  function prefetch(href){
    if(prefetched[href] || !href) return;
    prefetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = href;
    document.head.appendChild(l);
  }
  var hoverTimer;
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest('a[href^="/"]');
    if(!a || a.href.indexOf('#') > -1) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function(){ prefetch(a.getAttribute('href')); }, 65);
  });
  document.addEventListener('mouseout', function(){ clearTimeout(hoverTimer); });
  document.addEventListener('touchstart', function(e){
    var a = e.target.closest('a[href^="/"]');
    if(a) prefetch(a.getAttribute('href'));
  }, { passive:true });

  /* ---------- Predictive search overlay ---------- */
  var searchOverlay = document.querySelector('.search-overlay');
  var searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;
  var resultsEl = searchOverlay ? searchOverlay.querySelector('.search-results') : null;
  var searchCache = new Map();
  var controller = null;

  function el(tag, cls, text){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(text != null) n.textContent = text;
    return n;
  }

  var searchLastFocus = null;
  function openSearch(){
    if(!searchOverlay) return;
    searchLastFocus = document.activeElement;
    searchOverlay.removeAttribute('inert');
    searchOverlay.classList.add('open');
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 60);
  }
  function closeSearchOv(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('inert','');
    if(searchLastFocus && searchLastFocus.focus) searchLastFocus.focus();
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-search-open]')){ e.preventDefault(); openSearch(); return; }
    if(e.target.closest('[data-search-close]') || e.target === searchOverlay){ closeSearchOv(); return; }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')){ closeSearchOv(); return; }
    if(e.key !== 'Tab' || !searchOverlay || !searchOverlay.classList.contains('open')) return;
    var f = searchOverlay.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if(!f.length) return;
    var first = f[0], last = f[f.length-1];
    if(e.shiftKey && document.activeElement === first){ last.focus(); e.preventDefault(); }
    else if(!e.shiftKey && document.activeElement === last){ first.focus(); e.preventDefault(); }
  });

  function renderResults(data, q){
    if(!resultsEl) return;
    resultsEl.textContent = '';
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if(!products.length){
      resultsEl.appendChild(el('div','search-empty','No results for "' + q + '"'));
    } else {
      products.forEach(function(p){
        var a = el('a','search-result');
        a.href = p.url;
        if(p.image){
          var img = document.createElement('img');
          img.src = p.image; img.alt = p.title; img.width = 48; img.height = 48; img.loading='lazy';
          a.appendChild(img);
        }
        var box = el('div');
        box.appendChild(el('div','search-result__title', p.title));
        if(p.price){ var pr = window.WabringsCart ? window.WabringsCart.formatMoney(Math.round(parseFloat(p.price)*100)) : p.price; box.appendChild(el('div','search-result__price', pr)); }
        a.appendChild(box);
        resultsEl.appendChild(a);
      });
    }
    var all = el('a','search-all','Search for "' + q + '" →');
    all.href = window.routes.search_url + '?q=' + encodeURIComponent(q);
    resultsEl.appendChild(all);
  }

  function showSkeletons(){
    if(!resultsEl) return;
    resultsEl.textContent = '';
    for(var i=0;i<3;i++){
      var row = el('div','search-result');
      var sk = el('div','skeleton'); sk.style.width='48px'; sk.style.height='48px';
      var sk2 = el('div','skeleton'); sk2.style.flex='1'; sk2.style.height='16px';
      row.append(sk, sk2);
      resultsEl.appendChild(row);
    }
  }

  if(searchInput){
    var debounce;
    searchInput.addEventListener('input', function(){
      var q = searchInput.value.trim();
      clearTimeout(debounce);
      if(q.length < 2){ if(resultsEl) resultsEl.textContent=''; return; }
      debounce = setTimeout(function(){
        if(searchCache.has(q)){ renderResults(searchCache.get(q), q); return; }
        if(controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        showSkeletons();
        var url = (window.routes.predictive_search_url || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function(r){ return r.json(); })
          .then(function(data){ searchCache.set(q, data); renderResults(data, q); })
          .catch(function(err){ if(err.name !== 'AbortError' && resultsEl){ resultsEl.textContent=''; } });
      }, 300);
    });
    searchInput.closest('form') && searchInput.closest('form').addEventListener('submit', function(ev){
      ev.preventDefault();
      var q = searchInput.value.trim();
      if(q) window.location.href = window.routes.search_url + '?q=' + encodeURIComponent(q);
    });
  }

  /* ---------- Recently viewed (localStorage, safe) ---------- */
  var RV_KEY = 'wabrings-recently-viewed';
  function readRV(){
    try{
      var raw = localStorage.getItem(RV_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function(h){ return typeof h === 'string' && /^[a-z0-9-]+$/i.test(h); }) : [];
    }catch(e){ return []; }
  }
  function writeRV(arr){ try{ localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0,8))); }catch(e){} }

  var pdpEl = document.querySelector('[data-product-handle]');
  var currentHandle = pdpEl ? pdpEl.getAttribute('data-product-handle') : null;
  if(currentHandle){
    var rv = readRV().filter(function(h){ return h !== currentHandle; });
    rv.unshift(currentHandle);
    writeRV(rv);
  }

  var recentWrap = document.querySelector('[data-recently-viewed]');
  if(recentWrap){
    var handles = readRV().filter(function(h){ return h !== currentHandle; }).slice(0,4);
    if(handles.length){
      recentWrap.removeAttribute('hidden');
      var grid = recentWrap.querySelector('.grid');
      handles.forEach(function(h){
        fetch('/products/' + encodeURIComponent(h) + '.js', { headers:{ 'Accept':'application/json' } })
          .then(function(r){ if(!r.ok) throw new Error('nf'); return r.json(); })
          .then(function(p){
            var card = el('a','card');
            card.href = '/products/' + p.handle;
            var media = el('div','card__media');
            if(p.featured_image){
              var img = document.createElement('img');
              img.src = p.featured_image + (p.featured_image.indexOf('?')>-1 ? '&' : '?') + 'width=400';
              img.alt = p.title; img.loading = 'lazy'; img.width = 400; img.height = 400;
              media.appendChild(img);
            }
            card.appendChild(media);
            var body = el('div','card__body');
            body.appendChild(el('h3','card__title', p.title));
            var priceEl = el('div','card__price');
            priceEl.textContent = window.WabringsCart ? window.WabringsCart.formatMoney(p.price) : (window.moneyFormat||'').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (p.price/100).toFixed(2)) || (p.price/100).toFixed(2);
            body.appendChild(priceEl);
            card.appendChild(body);
            grid.appendChild(card);
          }).catch(function(){});
      });
    }
  }
})();
